<template>
    <v-container
        fluid
    >
        <div
            v-if="properties.length === 0"
            class="text-xs-center pt-2 pb-2 grey--text text--darken-1"
        >
            No results
        </div>

        <template v-else>
            <v-layout
                row
            >
                <v-flex
                    xs12
                >
                    <v-card>
                        <v-list
                            one-line
                        >
                            <v-list-group
                                v-for="(item, index) in properties"
                                :key="item.Code"
                                @click=""
                            >
                                <v-list-tile
                                    avatar
                                    ripple
                                    slot="item"
                                    @click="details(item.Code)"
                                >
                                    <v-list-tile-avatar
                                        v-if="item.Icon"
                                    >
                                        <v-icon>{{ item.Icon }}</v-icon>
                                    </v-list-tile-avatar>

                                    <v-list-tile-content>
                                        <v-list-tile-title class="bold">{{ item.Name }}</v-list-tile-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-list-tile-action-text>{{ item.Code }}</v-list-tile-action-text>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list-group>
                        </v-list>
                    </v-card>
                </v-flex>
            </v-layout>
        </template>
    </v-container>
</template>

<script>
    import { mapState } from 'vuex';
    import { pathToBreadcrumbs } from '../utils/breadcrumbs';

    export default {
        components: {
        },
        name: 'PropertiesList',
        props: {
            propspath: String,
        },
        data() {
            return {
                title: 'Properties',
            };
        },
        computed: {
            ...mapState('properties', {
                properties: state => state.properties,
            }),
        },
        methods: {
            details(code) {
                // we only go 1 level deep
                if (!this.propspath) {
                    const path = this.$route.path;
                    this.$router.push({ path: `${path}/${code}` });
                }
            },
            props(newPath) {
                const breadcrumbs = pathToBreadcrumbs({
                    id: 'properties',
                    text: 'Properties',
                    to: '/properties',
                },
                newPath);
                const lastId = breadcrumbs.length > 1
                    ? breadcrumbs[breadcrumbs.length - 1].id
                    : undefined;

                this.$store.commit('nav/BREADCRUMBS', breadcrumbs);
                this.$store.dispatch('properties/LIST_ALL', lastId);
            },
        },
        watch: {
            propspath(newPath) {
                this.props(newPath);
            },
        },
        created() {
            this.props(this.propspath);
        },
    };
</script>

<style scoped>
    .v-container {
        min-height: 0;
    }
</style>



// WEBPACK FOOTER //
// Properties.vue?18c02453